import { render, staticRenderFns } from "./BundlePurchaseNavigation.vue?vue&type=template&id=722aee84&"
import script from "./BundlePurchaseNavigation.vue?vue&type=script&lang=ts&"
export * from "./BundlePurchaseNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports